<template>
    <div class="share">
        <el-link :underline="false" type="primary" icon="el-icon-share" @click="handleShare">
            Udostępnij
        </el-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
      ...mapGetters('creator', [
        'project',
      ]),
    },
    methods: {
        handleShare() {
            if (this.project.hash) {
                this.$prompt('Poniżej znajduje się Twój link do udostępnienia', 'Udostępnij', {
                    inputValue: window.location.href,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Anuluj',
                })
            } else {
                this.$alert('W celu udostępnienia projektu konieczne jest najpierw jego zapisanie. Zapisz projekt i udostępnij ponownie.', 'Udostępnij')
            }
        },
    },
}
</script>